	<template>
	<v-card max-width="500px" class="mx-auto mt-4">
		<v-toolbar color="black" dark>
			<v-toolbar-title class="mw-h2">Account Set Up</v-toolbar-title>
			<v-spacer />
		</v-toolbar>
		<v-card-text>
			<v-text-field v-if="!id" v-model="email" label="Email Address"></v-text-field>
			<v-progress-linear v-if="running" indeterminate color="green" class="mt-3"></v-progress-linear>
			<v-alert type="warning" outlined dense v-if="false == success">Account not found. Please contact Meisterworks</v-alert>
			<v-alert type="success" outlined dense v-if="true == success">Thank you. Please check your email for further instructions</v-alert>
			<p v-if="link">{{link}}</p>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn text color="green" @click="go" v-if="!id && !success">Submit</v-btn>
		</v-card-actions>

	</v-card>
</template>

<script>
	import {checkAccount, processAccountSetUp, getPasswordResetLink} from "../assets/accountFunctions.js"
	export default {
		name: "RetrieveAccount", 
		props: {
			ref: {type: String }
		},
		methods: {
			go(){
				const self = this;
				self.running = true;
				if( self.admin ) {
					getPasswordResetLink(self.email).then( response => {
						self.link = response;
						self.running = false
						self.success = false;
					})
				}
				else{
					checkAccount(self.email).then( response => { 
						self.id = response.data;
					}).catch( () => {
						self.running = false
						self.success = false;
					})
				}
			}
		},
		computed: {
			admin(){
				return this.$store.state.admin.user.role == "admin"
			}
		},
		data: () => {
			return {
				id: false,
				email: "",
				running: false,
				link: false,
				success: null,
				
			}
		}, 
		watch: {
			id(){
				const self = this;
				if( self.id ){
					self.running = true;
					processAccountSetUp(self.id).then((response) => {
						self.running = false
						self.success = true;
						response;
					}).catch( () => {
						self.running = false
						self.success = false;
					})
				}
			},
			ref: {
				immediate: true, 
				handler(){
					const self = this;
					self.id = self.ref;
				}
			}
		}
	}
</script>